<template>
  <div>
    <div class="fullPageContent closed">      
      <DashboardHeader 
         v-bind:showMobileRightMenu ="false"
         v-bind:title="pageTitle" 
         v-bind:activeEl="activeEl">
      </DashboardHeader>
      <section class="allP wp1200">
            <TermsAndConditions></TermsAndConditions>
      </section>    

    </div>
  </div>
</template>
<script>
import  DashboardHeader from './partials/DashboardHeader.vue';
import  TermsAndConditions from './TermsAndConditions/TermsAndConditions.vue';

export default {
  data() {
    return {
      activeEl:null,
      pageTitle:this.$t("terms.title")
    };
  },
  computed: {},  
  components: {
    DashboardHeader,
    TermsAndConditions
  },
  mounted() {     
       this.$store.dispatch("app/loader", false);
  }
};
</script>
<style>

.vue-typer .custom.char.typed {
  color: #ffffff;
}
.vue-typer .custom.caret {
  display: none;
}
</style>